import { render, staticRenderFns } from "./SalarysetChangeList.vue?vue&type=template&id=2489c728"
import script from "./SalarysetChangeList.vue?vue&type=script&lang=js"
export * from "./SalarysetChangeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports